import {ComponentProps} from 'react';

import {Badge as BageDS} from '@optimaxdev/design-system';

import {BADGES} from '../../constants/badges';

enum BADGE_TYPE {
    SALES = 'sales',
    PREMIUM = 'premium',
    MISC = 'misc',
    ECO_CONSCIOUS = 'eco',
    LUXURY = 'luxury',
}

export enum BADGE_SIZE {
    MEDIUM = 'medium',
    LARGE = 'large',
}

export const BADGE_ID_DS_PROPS_MAP: Record<
    (typeof BADGES)[keyof typeof BADGES],
    ComponentProps<typeof BageDS>
> = {
    [BADGES.ECO_CONSCIOUS]: {
        children: 'Eco-conscious',
        diagonalRadius: false,
        size: BADGE_SIZE.LARGE,
        type: BADGE_TYPE.ECO_CONSCIOUS,
        withIcon: false,
    },
    [BADGES.LUXURY]: {
        children: 'Luxury',
        diagonalRadius: false,
        size: BADGE_SIZE.LARGE,
        type: BADGE_TYPE.LUXURY,
        withIcon: true,
    },
    [BADGES.MARSAI_MARTIN]: {
        children: 'Marsai Martin',
        diagonalRadius: false,
        size: BADGE_SIZE.LARGE,
        type: BADGE_TYPE.MISC,
        withIcon: false,
    },
    [BADGES.NEW]: {
        borderRadius: '5px',
        children: 'New',
        diagonalRadius: false,
        size: BADGE_SIZE.LARGE,
        type: BADGE_TYPE.SALES,
        withIcon: false,
    },
    [BADGES.NEW_ARRIVAL]: {
        children: 'New Arrival',
        diagonalRadius: false,
        size: BADGE_SIZE.LARGE,
        type: BADGE_TYPE.MISC,
        withIcon: false,
    },
    [BADGES.PREMIUM]: {
        children: 'Premium',
        diagonalRadius: false,
        size: BADGE_SIZE.LARGE,
        type: BADGE_TYPE.PREMIUM,
        withIcon: true,
    },
    [BADGES.SALE]: {
        children: 'Sale',
        diagonalRadius: false,
        size: BADGE_SIZE.LARGE,
        type: BADGE_TYPE.SALES,
        withIcon: true,
    },
    [BADGES.UPSELLS]: {
        children: '50% Off 2nd Pair',
        diagonalRadius: false,
        size: BADGE_SIZE.LARGE,
        type: BADGE_TYPE.SALES,
        withIcon: false,
    },
};
